import React, { useEffect } from 'react';

import { ConversationAssistantNavBarButton } from '@confluence/conversation-assistant/entry-points/navBarButton.ts';
import { RovoEntitlementSetter } from '@confluence/conversation-assistant/entry-points/conversation-assistant-entitlement.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { expValEquals } from '@confluence/feature-experiments';

export const RovoButton = (): React.JSX.Element => {
	const { isLoggedIn, isRovoLLMEnabled, accessStatus } = useSessionData();

	const isRovoEnabled =
		isRovoLLMEnabled && isLoggedIn && accessStatus !== AccessStatus.EXTERNAL_COLLABORATOR_ACCESS;

	useEffect(() => {
		if (isRovoEnabled) {
			expValEquals('cc-aifc-databases-experiment', 'isEnabled', true);
		}
	}, [isRovoEnabled]);

	return (
		<>
			{isRovoEnabled && <ConversationAssistantNavBarButton />}
			<RovoEntitlementSetter isRovoEnabled={isRovoEnabled} />
		</>
	);
};
